module.exports = __webpack_public_path__ + "img/Ptuapp1Phone.fb4a1d76.png";